export const required = [{ required: true, message: "Dato requerido." }];

export const inputs = [
{
    message: "Caracteres inválidos.",
    pattern: /^[a-zA-Z-áéíóúüÁÉÍÓÚÜ0-9]+[^\\_!"$%&()=?¡*'¨°|<>]+$/,
},
{ required: true, message: "Dato requerido." },
{ validateStatus: "error" },
];